import React, { Fragment } from 'react';
import classnames from 'classnames';
import AMEX from '../../assets/images/AMEX.png';
import Diners_Club from '../../assets/images/Diners_Club.png';
import Discover from '../../assets/images/Discover.png';
import JCB from '../../assets/images/JCB.png';
import Mastercard from '../../assets/images/Mastercard.png';
import Visa from '../../assets/images/Visa.png';

import './AcceptedPayment.scss';

const cards = [
  {
    name: 'visa',
    image: Visa,
  },
  {
    name: 'mastercard',
    image: Mastercard,
  },
  {
    name: 'discover',
    image: Discover,
  },
  {
    name: 'amex',
    image: AMEX,
  },
  {
    name: 'diners',
    image: Diners_Club,
  },
  {
    name: 'jcb',
    image: JCB,
  },
];

const AcceptedPayment = ({ activeCardCode, acceptedMethods }) => {
  return (
    <div>
      {cards.map(({ name, image }) => (
        <Fragment key={`ap-${name}`}>
          {acceptedMethods.includes(name) && (
            <span>
              {' '}
              <img
                width="75"
                src={image}
                alt="payment-img"
                className={classnames('mr-5 mb-10', { 'filter-grayscale': activeCardCode !== name })}
              />
            </span>
          )}
        </Fragment>
      ))}
    </div>
  );
};

export default AcceptedPayment;
